import { Package, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useFinancialWidgets } from '@/hooks/use-financial-widgets';
import { Card, CardContent } from '@/components/ui/card';

interface KpiTotalAssetsProps {
  readonly className?: string;
}

export function KpiTotalAssets({ className }: KpiTotalAssetsProps): React.ReactElement {
  const { useFinancialSummary } = useFinancialWidgets();
  const { data, isLoading } = useFinancialSummary();

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Total Assets"
      value={(data?.totalAssets ?? 0).toLocaleString()}
      change="—"
      changeLabel="across all locations"
      icon={Package}
      variant="info"
    />
  );
}
